import React from 'react';
import PropTypes from 'prop-types';

import {
  TextField as MuiTextField,
  InputAdornment,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';


import useStyles from './commonStyles';

const TextField = props => {
  const classes = useStyles();
  const { label, name, value, onChange, disabled, helperText, ...rest } = props;

  return (
    <MuiTextField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      fullWidth={true}
      InputLabelProps={{
        shrink: true,
        classes: {
          root: classes.textFieldLabel
        }
      }}
      InputProps={{
        classes: {
          root: classes.textFieldInput
        },
        endAdornment: !disabled ? (
          <InputAdornment position="end">
            <EditIcon color="primary" />
          </InputAdornment>
        ) : null
      }}
      helperText={helperText}
      {...rest}
    />
  );
}

TextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  helperText: PropTypes.string
}

export default TextField;
